import { render, staticRenderFns } from "./RewardCoins.vue?vue&type=template&id=019283fc&"
import script from "./RewardCoins.vue?vue&type=script&lang=ts&"
export * from "./RewardCoins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports